import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs: Crumb[];
  children?: ReactNode;
}

export default function PageHeader({
  eyebrow,
  title,
  description,
  crumbs,
  children,
}: PageHeaderProps) {
  return (
    <section className="bg-primary-900 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, oklch(var(--accent-500)) 0, transparent 45%), radial-gradient(circle at 80% 60%, oklch(var(--primary-400)) 0, transparent 50%)",
        }}
      ></div>
      <div className="relative max-w-site mx-auto px-4 md:px-6 pt-10 md:pt-14 pb-10 md:pb-14">
        <Breadcrumb items={crumbs} />
        <div className="mt-6 max-w-3xl">
          {eyebrow && (
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] text-accent-300 mb-3">
              {eyebrow}
            </p>
          )}
          <h1 className="text-2xl md:text-4xl font-heading font-semibold text-background-50 leading-tight">
            {title}
          </h1>
          {description && (
            <p className="mt-4 text-sm md:text-base text-primary-200 leading-relaxed">
              {description}
            </p>
          )}
        </div>
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}